import getListViewDimensions from './getListViewDimensions';
import { MIN_LIST_VIEW_WIDTH } from './constants';
var LIST_VIEW_NOTIFICATION_PADDING = 24;
export default function getListViewNotificationDimensions() {
    return {
        minWidth: MIN_LIST_VIEW_WIDTH - LIST_VIEW_NOTIFICATION_PADDING,
        maxWidth: getListViewDimensions().listViewWidth - LIST_VIEW_NOTIFICATION_PADDING,
    };
}
//# sourceMappingURL=getListViewNotificationDimensions.js.map